module.exports = __webpack_public_path__ + "img/Flag_of_Estonia.8665c242.svg";